
export default class ChatTo {
    // Chat To
    static readonly NONE = -1;
    static readonly PRIVATE = 0;
    static readonly TABLE = 1;
    static readonly SPECTATORS = 2;
    static readonly LEFT = 3;
    static readonly EXPLANATION = 5;
    static readonly LOBBY = 6;
    static readonly TOURNAMENT_DIRECTOR = 7;
    static readonly RIGHT = 4;
    static readonly BROADCAST = 8;
    static readonly SYSTEM = 9;
    static readonly BROADCAST_SPECTATORS = 10;
    static readonly PRIVATE_CONTROL = 100;

    target: number | string;

    constructor(target?: number) {
        if (target) {
            this.target = target;
        } else {
            this.target = ChatTo.NONE;
        }
    }

    getPrivateName() {
        // the select on the form will set the target as the private name.
        const s = `${this.target}`;
        if (isNaN(parseInt(s))) {
            return s;
        }
        return undefined;
    }

    isPrivate() {
        if (this.target === ChatTo.PRIVATE) {
            return true;
        }

        const s = `${this.target}`;
        if (isNaN(parseInt(s))) {
            return true;
        }

        return false;
    }

    isBroadcast() {
        return this.target == ChatTo.BROADCAST;
    }

    isNone() {
        return this.target == ChatTo.NONE;
    }
}
